import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowleft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.625 23.625L13.6739 21.5761L5.56547 13.4531L23.25 13.4531L23.25 10.5469L5.56547 10.5469L13.6739 2.42391L11.625 0.375001L-1.01629e-06 12L11.625 23.625Z",
		fill: "currentcolor"
	})
});
export default SvgArrowleft;
